import { APP_NAME } from '@clanfire/shared';
import { cn } from '@/lib/utils';

/** The app's mark, as a jack-o'-lantern on 31 October. Replace it by editing /brand and running `npm run brand`. */
export const logoSrc = () => {
  const today = new Date();
  return today.getMonth() === 9 && today.getDate() === 31 ? '/brand/logo-halloween.svg' : '/brand/logo.svg';
};

export function Logo({ size = 32, className }: { size?: number; className?: string }) {
  return <img src={logoSrc()} alt="" width={size} height={size} className={cn('shrink-0 select-none', className)} draggable={false} />;
}

/** "ClanFire" -> ["Clan", "Fire"]: the last capitalised word takes the accent. */
const [NAME_HEAD, NAME_TAIL] = (() => {
  const m = /^(.+?)([A-Z][a-z]+)$/.exec(APP_NAME);
  return m ? [m[1]!, m[2]!] : [APP_NAME, ''];
})();

export function Wordmark({ className, size = 30 }: { className?: string; size?: number }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <Logo size={size} />
      <span className="font-display leading-none" style={{ fontSize: size * 0.8 }}>
        {NAME_HEAD}
        {NAME_TAIL && <span className="text-accent">{NAME_TAIL}</span>}
      </span>
    </span>
  );
}
